<template>
  <div class="animated fadeIn">
      <spinner v-if="loading"/>
      <b-card>
        <div slot="header">
            <strong>Search PO</strong>
        </div>
        <b-row>
            <b-col sm="2">
                <b-form-group>
                  <label for="po_num">PO No</label>
                  <b-form-input type="text" id="po_num" v-model="filter.po_num" @keyup.enter="search" v-on:keyup.enter="$event.target.nextElementSibling.focus()"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="2">
                <b-form-group>
                  <label for="supplier_id">Supplier</label>
                  <supplierLookup v-bind:url="apiUrl" v-on:selected="setSupplierId($event)" :lookupId="filter.supplier_id"></supplierLookup>
              </b-form-group>
              </b-col>
              <b-col sm="2">
              <b-form-group>
                  <label >GRN No</label>
                  <b-form-input type="text"  v-model="filter.grn_num"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                  <label >PO Date</label>
                  <b-form-input type="text"  v-model="filter.po_date"></b-form-input>
              </b-form-group>
            </b-col>
              <b-col sm="2">
                <b-form-group >
                    <label for="po_status">PO Status</label>
                    <b-form-select id="po_status" v-model="filter.po_status"
                      :plain="true"
                      :options="['','PENDING', 'APPROVED', 'CANCELLED']"
                      value="">
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group >
                    <label for="po_fulfilment_status">Fulfilment Status</label>
                    <b-form-select id="po_fulfilment_status" v-model="filter.po_fulfilment_status"
                      :plain="true"
                      :options="['','PARTIAL', 'FULFILLED', 'MANUAL CLOSED','UNFULFILLED']"
                      value="">
                    </b-form-select>
                  </b-form-group>
              </b-col>
          </b-row>
        <div slot="footer">
            <b-button type="submit" size="lg" variant="primary" @click="search"> Search</b-button>
        </div>
      </b-card>
        <b-row v-if="getRowCount(searchResults) > 0 && !loading">
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Search Results</strong>
                      </div>
                      <div class="table-responsive">
                        <b-table class="table-hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                          :per-page="perPage" :items="searchResults">
                        </b-table>
                      </div>
                    <nav>
                        <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                    <div slot="footer">
                        <exportExcel
                          class   = "btn btn-primary btn-lg"
                          size ="lg"
                          :data   = "searchResults"
                          :fields = "exportHeaders"
                          name    = "po.xls">
                          Export to Excel
                      </exportExcel>
                      &nbsp;&nbsp;
                      <b-button type="button" size="lg" variant="success" @click="print">Print</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-else-if="noResults" >
            <b-col sm="12">
              <div align="center">
                <strong>No Data Found</strong>
              </div>                    
            </b-col>
        </b-row>
    </b-row>
  </div>
</template>
<script>
  import axios from 'axios'
  import {apiSupplierLookup, apiPoSearch,authHeader, apiPoGrnTrackingReport} from '@/functions/common.vue'
  import supplierLookup from '@/components/Autocomplete.vue'
  import spinner from '@/components/Spinner.vue'
  import exportExcel from 'vue-json-excel' 

  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
          normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
            bolditalics: 'ukai.ttf'
      },
      "Roboto": {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-Italic.ttf'
        },
    };
  export default 
  {
    components: {supplierLookup, spinner,exportExcel},
    props: {
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data () {
    return {
      loading: false,
      filter: {
        po_num: '',
        grn_num:'',
        supplier_id: '',
        po_date: '',
        last_grn_date:'',
        po_status: '',
        po_fulfilment_status:''
      },
      apiUrl: apiSupplierLookup,
      supplier_fullId: '',
      seen :false,
      searchResults: [],
      searchResultsFields: [
        {key: 'po_num', label: 'PO No'},
        {key: 'po_date' ,label: 'PO Date'},
        {key: 'supplier_full' ,label: 'Supplier'},
        {key: 'po_type' ,label: 'Type'},
        {key: 'po_category' ,label: 'Category'},
        {key: 'po_status' ,label: 'PO Status'},
        {key: 'po_fulfilment_status' ,label: 'Fulfilment Status'},
        {key: 'grns_list' ,label: 'GRN List'},
        {key: 'last_grn_date' ,label: 'Last GRN Date'},
        {key: 'location_id' ,label: 'Location'},
        {key: 'product_code' ,label: 'SKU'},
        {key: 'qty' ,label: 'PO Qty'},
        {key: 'qty_received' ,label: 'Received Qty'},
        {key: 'qty_balance' ,label: 'Balance Qty'},
        {key: 'remarks' ,label: 'PO Remarks'},
        {key: 'last_grn_remarks' ,label: 'Last GRN Remarks'},
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      noResults: false,
      exportHeaders:
        {
          'PO No': 'po_num',
          'Date': 'po_date',
          'Supplier Ful': 'supplier_full',
          'PO Status':'po_status',
          'Fulfilment Status':'po_fulfilment_status',
          'GRN List':'grns_list',
          'Last GRN Date':'last_grn_date',
          'Location':'location_id',
          'SKU':'product_code',
          'Description':'product_name',
          'PO Qty':'qty',
          'GRN Qty':'qty_received',
          'Qty Balance':'qty_balance',
          'PO Remarks': 'remarks',
          'Last GRN Remarks': 'last_grn_remarks'
        },
    }
    },
    created () 
    {
      const auth_header = localStorage.access_token;
      window.addEventListener('keyup', this.checkKey)
    },
    methods:
    {
      print()
        {
          var rows = []
          var row = []
          var date = new Date()
          rows.push([
          'PO No',
          'PO Date',
          'supplier_full',
          'PO Status',
          'Fulfilment Status',
          'GRN No',
          'Last GRN Date',
          'Location',
          'SKU',
          'PO Qty',
          'GRN Qty',
          'Qty Balance'
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [
            data.po_num, data.po_date, 
            data.supplier_full,data.po_status, 
            data.po_fulfilment_status, data.grns_list, data.last_grn_date,data.location_id, data.product_code,
            data.qty, data.qty_received, data.qty_balance]
            rows.push(row)
          }
          var dd = {
            header:{ text: 'PO & GRN Tracking Report generated on'+ " "+ date, margin: [ 5, 10, 10, 20 ],alignment: 'center',fontSize:7 },
            pageSize: 'A4',
            pageOrientation: 'landscape',
            defaultStyle: {
            font: 'ukai',
          },
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 20, 30, 20 ],

                    content: [
                      {
                          fontSize: 10,
                          layout: 'lightHorizontalLines', // optional
                          table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            headerRows: 1,
                            widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto','auto' ],

                            body: 
                              rows
                            
                          }
                        }
                      ]
          };

          pdfMake.createPdf(dd).open();
        },
        checkKey(e)
        {
          if (e.key == 'Enter')
          {
            //this.target.nextElementSibling.focus()
          }
        },
        search()
        {
          this.loading = true
          this.submitted =true
          this.seen =true
          var sf =
          [
            "po_num LIKE " + this.filter.po_num
            ,"supplier_id = " + this.filter.supplier_id
            ,"po_date = " + this.filter.po_date
            ,"grns_list = " + this.filter.grn_num
            ,"po_status = " + this.filter.po_status
            ,"po_po_fulfilment_status = " + this.filter.po_fulfilment_status
          ]
            axios.post(apiPoGrnTrackingReport, sf,authHeader())
              .then (res => 
              {
                return res
                
              })
              .then (data =>
              {
                const resultArray = []
                const myData = data.data.data
                
                for (let key in myData)
                {
                  var date = myData[key].po_date
                  var date = new Date(date);
                  var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                  myData[key].po_date = result

                  var grn_date = myData[key].last_grn_date
                  var grn_date = new Date(grn_date);
                  var grn_result = "" + (grn_date.getDate() > 9 ? '' : '0') + grn_date.getDate() + '/'+  ((grn_date.getMonth() + 1) > 9 ? '' : '0') + (grn_date.getMonth() + 1) + '/' + grn_date.getFullYear()
                  myData[key].last_grn_date = grn_result

                  var qty = myData[key].qty
                  myData[key].qty = qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")


                  var qty_received = myData[key].qty_received
                  myData[key].qty_received = qty_received.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                  var qty_balance = myData[key].qty_balance
                  myData[key].qty_balance = qty_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                  resultArray.push(myData[key])
                  this.loading = false
                }
          
                this.searchResults = resultArray
                if(this.searchResults.length ==0)
                {
                  this.loading = false
                  this.noResults =true
                }
              })
              .catch(error => console.log(error))

        },
        setSupplierId(obj)
        {
          var id

          if (obj !== null)
            id = obj.id
          else
            id = ''

          this.filter.supplier_id = id
        },
        getRowCount (list) 
        {
          return list.length
        },

    },
  }
</script>
<style>
    .main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/views/reports/po_grn_tracking.vue